import { Section } from "../types";

export const sections_bg: Section[] = [
  {
    title: "Оценка на стила на обучение",
    questions: [
      {
        question:
          "Кои предмети ви харесват най-много в периода 9 - 12 клас? (можете да маркирате минимум 1 и максимум 2)",
        options: [
          {
            option: "Български език и литература",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option: "Чужди езици",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            option: "Биология/химия",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "Физика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "Математика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "География",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option:
              "Икономика/предприемачество или други подобни предмети от търговски и финансови професионални гимназии",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "История",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "Философия/психология",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "ИТ/компютърно програмиране или други технологични предмети от професионалните гимназии",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Гражданско образование",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option:
              "Изкуства/дизайн или други подобни предмети от професионалните художествени гимназии",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Музика/танц/актьорско майсторство",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
            },
          },
          {
            option: "Физическо възпитание и спорт",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
            },
          },
        ],
        multiSelect: true,
        minSelect: 1,
        maxSelect: 2,
      },
      {
        question:
          "Кои от тези предмети избрахте като основни предмети в училище? (можете да маркирате минимум 1 и максимум 4)",
        options: [
          {
            option: "Български език и литература",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Чужди езици",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            option: "Биология/химия",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "Физика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "Математика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "География",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option:
              "Икономика/предприемачество или други подобни предмети от търговски и финансови професионални гимназии",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "История",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "Философия/психология",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "ИТ/компютърно програмиране или други технологични предмети от професионалните гимназии",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Гражданско образование",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option:
              "Изкуства/дизайн или други подобни предмети от професионалните художествени гимназии",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Музика/танц/актьорско майсторство",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
            },
          },
          {
            option: "Физическо възпитание и спорт",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
            },
          },
        ],
        multiSelect: true,
        minSelect: 1,
        maxSelect: 4,
      },
      {
        question: "Какво мислиш за математиката?",
        options: [
          {
            option: "С удоволствие и желание",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "Приемам го и се справям добре с него, ако е необходимо.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Аз съм добре, само когато това е приложимо на практика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Предпочитам да го избегна.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "Не обичам математика.",
            scores: {
              "MO/POLITICS": 4,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
            },
          },
        ],
      },
      {
        question:
          "Какъв тип домашна работа правите най-добре и се наслаждавате най-много?",
        options: [
          {
            option: "Логически и математически проблеми",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
            },
          },
          {
            option: "Писане на есе",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option: "Научни/изследователски проекти",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Подготовка на индивидуална презентация",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "Групов проект/презентация",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option:
              "Възможност за себеизразяване, творчество и критично мислене",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 3,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
        ],
      },
      {
        question: "Как най-лесно научаваш нова информация/нов урок?",
        options: [
          {
            option: "Чрез логика и практика",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option: "Чрез четене и извличане на важната информация",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "чрез запаметяване на целия текст и преразказване",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Чрез анализ и обсъждане на темата",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option: "Чрез чертежи, графики, за да го запомните визуално",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 2,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 3,
            },
          },
          {
            option: "Чрез асоциации с други теми/събития/личности",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
        ],
      },
      {
        question:
          "Каква роля обичате да играете в екипа при подготовката на съвместен проект в училище?",
        options: [
          {
            option:
              "Вие избирате стратегията за подготовка и разпределяте задачите.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Пишеш текста на проекта, защото се изразяваш най-добре.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option: "Вие сте този, който търси информация.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
              "Translator/teacher": 3,
            },
          },
          {
            option: "Представяте проекта на учителите.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "Вие проектирате графиките и слайдовете на презентацията.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option:
              "Обичам да участвам във всички части по-горе, защото мога да ги направя добре.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
        ],
      },
      {
        question:
          "В какъв курс бихте се записали или практикували в свободното си време?",
        options: [
          {
            option: "Компютри или програмиране",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Творческо писане или философия",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option: "Експерименти и изследвания",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "Дигитален маркетинг",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
            },
          },
          {
            option: "Разисквания",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option: "Свързани с чертежа",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Музика или актьорско майсторство",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Бизнес клуб",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Нещо, свързано с благотворителна дейност",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
        ],
      },
      {
        question: "Какво цениш най-много в учебния процес?",
        options: [
          {
            option: "Когато урокът е структуриран и логично насочен",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 2,
            },
          },
          {
            option: "Когато имаш право на собствено мнение и критично мислене",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "Когато урокът е свързан с природата и здравето",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option:
              "Когато урокът е за изследване, анализ и вземане на решения",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Свобода на творчеството и себеизразяване",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
        ],
      },
      {
        question: "Какво те вдъхновява, когато си представяш бъдещето?",
        options: [
          {
            option: "Нови иновации и технологии",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option:
              "Психология и как тя помага на хората да разберат себе си и да изградят в правилната посока, като вземат разумни и добре обмислени решения",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "Открития в медицината и други научни области, които променят живота и ежедневието ни",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Известни хора като Бил Гейтс, Илон Мъск",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "Създаване на иновативни сгради и проекти",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "Инстаграм пространството и инфлуенсърите, които живеят най-добрия живот, за който мечтая",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Поведение",
    questions: [
      {
        question: "Каква е вашата толерантност към стресови ситуации?",
        options: [
          {
            option: "Аз се справям добре под стрес и натиск.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
            },
          },
          {
            option: "Стресът е предизвикателство, но мога да се справя.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "Опитвам се да избегна стресови конфликти.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "Работя много по-добре в спокойна среда.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "Не мога да се концентрирам в стресови моменти.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
        ],
      },
      {
        question:
          "Как реагирате, когато някой ви помоли за помощ, въпреки че не сте много компетентни в тази област?",
        options: [
          {
            option:
              "Вярвам, че съм достатъчно интелигентен, за да помогна във всяка област.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option:
              "Бих помогнал от учтивост, дори ако не съм напълно наясно по темата.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option:
              "ще ви предупредя предварително, че не съм компетентен в тази област, но вярвам, че заедно ще намерим начин и решение.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option:
              "По-скоро бих отказал да помогна, отколкото да разочаровам някого.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
            },
          },
        ],
      },
      {
        question: "Закъснявате с крайния срок на проекта си, какво ще правите?",
        options: [
          {
            option: "Ще го предам там, където съм, и ще се извиня на учителя.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option:
              "Ще дам като извинение, че съм болна, не се чувствах добре и това е причината.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Ще говоря с учителя предварително за отлагане.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
            },
          },
          {
            option: "Ще прекарам цялата нощ на компютъра, докато го довърша.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option: "Никога не закъснявам!",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
        ],
      },
      {
        question:
          "Виждате съученик да изневерява и той постоянно се хвали, че е най-умният в класа. Как бихте реагирали?",
        options: [
          {
            option:
              "Това не е моя работа, има учители, които трябва да го видят.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option:
              "Ще отида внимателно и ще информирам учителя, без целият клас да разбере.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 1,
              "Translator/teacher": 1,
            },
          },
          {
            option:
              "Ще му се подигравам, като стана и публично го изложа пред съучениците му и учителя.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option:
              "Без значение колко копира, той не може да направи повече от мен.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 4,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
        ],
      },
      {
        question:
          "Когато спориш с някой, който има също толкова силни аргументи",
        options: [
          {
            option:
              "Склонен съм да отстъпя и да приема тяхната страна като вярна.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option:
              "няма да отстъпя, като се има предвид, че съм убеден в истината на моите аргументи.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option:
              "Ще намеря общо решение, което да удовлетворява и двете страни.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
            },
          },
          {
            option:
              "Ще използвам изкривени аргументи, за да отслабя неговата версия.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
        ],
      },
      {
        question:
          "Гледате любимото си шоу на живо в театър. Внезапно домакинът сочи към вас и ви кани на сцената като част от сценичен акт / игра.",
        options: [
          {
            option: "Ти си супер ентусиазиран и скачаш точно на сцената.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option:
              "Разбира се, че ще се присъединя веднага щом ме пуснат по телевизията.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "Бих се чувствал специален, но бих предпочел да кажа не.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 1,
              "Translator/teacher": 1,
            },
          },
          {
            option: "Определено отказвам.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option: "Предпочитам да си тръгна сега, защото ще умра от срам.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
        ],
      },
      {
        question: "Някой ти дължи пари, но ги намираш да пазаруват дрехи?",
        options: [
          {
            option: "Ще го помолиш учтиво да ми ги върне.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
            },
          },
          {
            option: "Ще го поканя на обяд/вечеря и ще го накарам да си плати.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
            },
          },
          {
            option: "Ще публикувам нещо непряко в социалните медии.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
            },
          },
          {
            option: "Ще се срещна с него и ще го намеря там.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Умения",
    questions: [
      {
        question: "Предпочитате ли да работите в екип или сами?",
        options: [
          {
            option: "Предпочитам да върша собствената си работа.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
            },
          },
          {
            option: "Мога да работя еднакво добре в екип и независимо.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
          {
            option:
              "Харесва ми да работя в група, където можем да обменяме идеи и опит.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
        ],
      },
      {
        question:
          "Предпочитате ли да ръководите и да поемете отговорност или да следвате и изпълнявате задачи?",
        options: [
          {
            option: "Винаги демонстрирам лидерските си качества.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "Аз се справям добре и в двете роли.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
            },
          },
          {
            option: "Не обичам да поемам отговорност.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
        ],
      },
      {
        question:
          "Обичате ли да експериментирате и да опитвате нови неща или предпочитате статуквото, а не промяната?",
        options: [
          {
            option:
              "Предпочитам да използвам доказани методи без риск от грешки.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
          {
            option: "Опитвам нови неща от време на време, без да прекалявам.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
            },
          },
          {
            option:
              "Обичам да експериментирам със себе си, с обстоятелствата и всичко около мен.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
        ],
      },
      {
        question:
          "Можете ли да се идентифицирате с един от 3-те типа хора и кой?",
        options: [
          {
            option: "Интроверт",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
          {
            option: "Мисля, че съм малко и от двете, без да съм в крайност.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
            },
          },
          {
            option: "Екстроверт и душата на компанията",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
        ],
      },
      {
        question: "Спечели самолетен билет за двама до Ню Йорк като награда?",
        options: [
          {
            option:
              "Първо ще потърся някой, който би се съгласил да дойде с мен.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 3,
              "ACTORS/MUSICIANS": 2,
              "Translator/teacher": 2,
            },
          },
          {
            option:
              "Вече резервирах хотела и си опаковам багажа, независимо дали някой иска да дойде или не.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option:
              "Ще обсъдя с моите родители/брат/сестра, които биха ме придружили - все пак това е другата страна на света",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Предпочитания за кариера",
    questions: [
      {
        question: "Изберете една професия от всяка двойка:",
        type: "profession-choice",
        options: [
          {
            option: "Космонавт",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
          {
            option: "Държавна работа в Министерството на здравеопазването",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "ТВ шоу водещ",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Индустриален инженер",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Предварително пиене",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
            },
          },
          {
            option: "Банкер",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "Доктор",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Архитект",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Дизайнер на продукти",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Дипломат",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option: "Детски учител",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Лабораторен асистент",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "HR специалист",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option: "Хотелски рецепционист",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
        ],
        professionPairs: [
          [
            {
              option: "Космонавт",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 2,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 3,
                "GOVERNMENT WORK": 2,
                "COSMONAUT/DISCOVERER": 2,
                "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              },
            },
            {
              option: "Министерството на здравеопазването",
              scores: {
                "MO/POLITICS": 2,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              },
            },
          ],

          [
            {
              option: "ТВ шоу водещ",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 3,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 3,
              },
            },
            {
              option: "Индустриален инженер",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 3,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
                "MILITARY/DEFENSE": 1,
              },
            },
          ],

          [
            {
              option: "Предварително пиене",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 1,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
                "MILITARY/DEFENSE": 1,
                "GOVERNMENT WORK": 1,
              },
            },
            {
              option: "Банкер",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 1,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              },
            },
          ],

          [
            {
              option: "Доктор",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 2,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 1,
              },
            },
            {
              option: "Архитект",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 3,
              },
            },
          ],

          [
            {
              option: "Дизайнер на продукти",
              scores: {
                "MO/POLITICS": 2,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
                "MILITARY/DEFENSE": 1,
              },
            },
            {
              option: "Дипломат",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 2,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 2,
              },
            },
          ],

          [
            {
              option: "Детски учител",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 3,
              },
            },
            {
              option: "Лабораторен асистент",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 1,
              },
            },
          ],
          [
            {
              option: "HR специалист",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 2,
              },
            },
            {
              option: "Хотелски рецепционист",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 1,
              },
            },
          ],
        ],
      },
    ],
  },
  {
    title: "Съвпадение на професионалните задачи",
    questions: [
      {
        question: "Съчетайте всяка професия със съответната й task:",
        type: "profession-task",
        options: [],
        pairs: [
          {
            profession: "Финансов анализатор",
            task: "Банкови/борсови операции",
            scores: {
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            profession: "Графичен дизайнер",
            task: "Създаване на билбордове и брошури",
            scores: { "MARKETING PR ADVERTISING EVENTS": 3 },
          },
          {
            profession: "народен представител",
            task: "Представител на Европейския парламент",
            scores: { "MO/POLITICS": 3, "GOVERNMENT WORK": 2 },
          },
          {
            profession: "Предприемач",
            task: "Собственик на бизнес",
            scores: { "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3 },
          },
          {
            profession: "журналист",
            task: "Писане на вестник/списание",
            scores: { "MEDIA COMMUNICATIONS PR": 3 },
          },
          {
            profession: "Социолог",
            task: "Изследване и анализ на общественото мнение",
            scores: { "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3 },
          },
          {
            profession: "Ядрен инженер",
            task: "Експлоатация на АЕЦ",
            scores: {
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
            },
          },
          {
            profession: "Дизайнер на игри",
            task: "Minecraft",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "директор",
            task: "Театрална/филмова продукция",
            scores: { "MEDIA COMMUNICATIONS PR": 3 },
          },
          {
            profession: "Историк",
            task: "Музейна курация",
            scores: { "WORK IN A GALLERY/MUSEUM/ART": 3 },
          },
          {
            profession: "Филолог",
            task: "Преводачески услуги",
            scores: { "Translator/teacher": 3 },
          },
          {
            profession: "Архитект",
            task: "Проектиране и строителство на сгради",
            scores: { "ARCHITECTURE/CONSTRUCTION": 3 },
          },
          {
            profession: "Служител по сигурността", // Променено от "Берета"
            task: "Поддържане на обществения ред",
            scores: { "ВОЕННИ/ОТБРАНИТЕЛНИ": 3 },
          },
          {
            profession: "терапевт",
            task: "Консултиране по психично здраве",
            scores: { "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3 },
          },
          {
            profession: "Маркетинг специалист",
            task: "Разработване и управление на кампании",
            scores: { "MARKETING PR ADVERTISING EVENTS": 3 },
          },
          {
            profession: "SEO специалист",
            task: "Оптимизация на дигиталната платформа",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "Модел",
            task: "Бранд и модно представителство",
            scores: { "MEDIA COMMUNICATIONS PR": 2 },
          },
          {
            profession: "Бариста",
            task: "Сервиране и приготвяне на кафе",
            scores: { "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1 },
          },
          {
            profession: "AI Engineer",
            task: "Развитие на изкуствения интелект",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "Биохимик",
            task: "Лабораторни изследвания",
            scores: { "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3 },
          },
          {
            profession: "Адвокат",
            task: "Правно представителство и застъпничество",
            scores: { "LEGAL PROFESSIONS/JUDGE/NOTARY": 3 },
          },
          // ... добавете всичките си двойки тук
        ],
        availableProfessions: [
          "Адвокат",
          "Дизайнер на игри",
          "Маркетинг специалист",
          "SEO специалист",
          "директор",
          "Ядрен инженер",
          "журналист",
          "Графичен дизайнер",
          "Бариста",
          "Архитект",
          "Инженер на изкуствения интелект",
          "Модел",
          "Филолог",
          "Социолог",
          "терапевт",
          "Предприемач",
          "Служител по сигурността",
          "Член на Парламента",
          "Финансов анализатор",
          "Биохимик",
          "Историк",
          // ... добавят се всички професии
        ],
        availableTasks: [
          "Банкови/фондови операции",
          "Създаване на билбордове и брошури",
          "Представител на Европейския парламент",
          "Собственик на бизнес",
          "Писане на вестник/списание",
          "Изследване и анализ на общественото мнение",
          "Експлоатация на АЕЦ",
          "Minecraft",
          "Театрална/филмова продукция",
          "Музейна курация",
          "Преводачески услуги",
          "Проектиране и строителство на сгради",
          "Поддържане на обществения ред",
          "Консултиране по психично здраве",
          "Разработване и управление на кампании",
          "Оптимизация на дигитална платформа",
          "Бранд и модно представителство",
          "Сервиз и приготвяне на кафе",
          "Изкуствен интелект",
          "Лабораторни изследвания",
          "Правно представителство и застъпничество",
          // ... добавяне на всички задачи
        ],
      },
    ],
  },
];
